type WorkloadCostIdentity = {
  workloadName?: string;
  workloadType?: string;
  namespace?: string;
};

/** Matches cost-report list hooks (`usePaginatedWorkloadCostSummariesQuery`, etc.). */
export const buildInventoryWorkloadCostItemId = ({
  workloadName,
  workloadType,
  namespace,
}: WorkloadCostIdentity) => `${workloadName}-${workloadType}-${namespace}`;
